<template>
  <Card
    v-bind="$attrs"
    clickable
    :morph="file.timeline_morph"
    :pinned="file.timeline_pinned"
    :simple="simple"
  >
    <q-item-section>
      <div class="text-caption text-bold q-mb-xs">
        <span class="q-pr-xs">
          ({{ $formatSystemDate(file.timeline_date, fullDate || file.timeline_pinned ? luxonFormats.SHORT_WORDED_DATE_TIME : luxonFormats.TIME) }})
        </span>
        <span>
          {{ file.timeline_morph ? file.timeline_morph.type : null }} File
        </span>
      </div>

      <file-view-card
        :file="file"
        read-only
        invisible
        clickable-side
        @details="viewingFileID = file.id"
      />
    </q-item-section>

    <template #menu>
      <q-item-wrapper
        v-close-popup
        clickable
        icon="mdi-file"
        label="View File..."
        @click="viewingFileID = file.id"
      />
      <q-item-wrapper
        v-if="!readOnly && !disablePinning"
        v-close-popup
        clickable
        :icon="file.timeline_pinned ? 'mdi-pin-off-outline' : 'mdi-pin-outline'"
        :label="file.timeline_pinned ? 'Unpin File' : 'Pin File'"
        @click="pinAttachment"
      />
      <q-separator
        v-if="!readOnly"
        inset
        class="q-my-sm"
      />
      <q-item-wrapper
        v-if="!readOnly"
        v-close-popup
        clickable
        color="red-8"
        class="text-bold"
        icon="mdi-close"
        label="Remove"
        @click="$emit('remove')"
      />
    </template>
  </Card>

  <ViewFileDialog
    :id="viewingFileID"
    :can-delete="!readOnly"
    @close="viewingFileID = null"
    @saved="onFileSaved"
    @deleted="removeFile(true)"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

import Card from 'components/partials/timeline/partials/Card'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Card,
    ViewFileDialog: defineAsyncComponent(() => import('src/components/app/files/partials/view/Dialog'))
  },
  mixins: [cardMixin],
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  emits: ['remove', 'pin'],
  data () {
    return {
      viewingFileID: null
    }
  },
  methods: {
    removeFile (silent = false) {
      this.$emit('remove', silent)
    },
    onFileSaved (file) {
      this.file.title = file.title
    },
    pinAttachment () {
      this.file.timeline_pinned = !this.file.timeline_pinned
      this.$emit('pin')
    }
  }
}
</script>
